// src/hooks/useSticky.js

import { useState, useEffect } from "react";

/**
 * Custom hook to handle sticky behavior based on scroll position.
 * @param {number} threshold - The scroll threshold to trigger the sticky state.
 * @returns {Object} - Object containing isSticky state and navbarHeight
 */
const useSticky = (threshold) => {
  const [isSticky, setIsSticky] = useState(false);
  const [navbarHeight, setNavbarHeight] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsSticky(scrollTop > threshold);
    };

    const updateNavbarHeight = () => {
      // Find the navbar element
      const navbar = document.querySelector(".MuiAppBar-root");
      if (navbar) {
        setNavbarHeight(navbar.offsetHeight);
      }
    };

    // Initial checks
    handleScroll();
    updateNavbarHeight();

    // Set up event listeners
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", updateNavbarHeight);

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", updateNavbarHeight);
    };
  }, [threshold]);

  return { isSticky, navbarHeight };
};

export default useSticky;
